import { InjectionToken } from '@angular/core';

import { BaasCommonApiClient } from '@lvflanders/bar';

import { BarErrorHandlerHook } from '../hooks/bar-error-handler.hook';
import { BarInitializedHook } from '../hooks/bar-initialized.hook';

/** Token to resolve BaasCommonApiClient interface. */
export const BAAS_COMMON_API_CLIENT = new InjectionToken<BaasCommonApiClient>('BaasCommonApiClient token.');
/** Token for BAR initialized lifecycle hook. */
export const BAR_INITIALIZED = new InjectionToken<BarInitializedHook>('BAR initialized token.');
/** Token for BAR error handler hook. */
export const BAR_ERROR_HANDLER = new InjectionToken<BarErrorHandlerHook>('BAR error handling token.');
